import { nanoid } from 'nanoid'

export const generateFlowActionId = (id: string) => `${id}_${String(nanoid()).replace(/-/g, '')}`
